import classNames from 'classnames';
import FundsSearch from 'components/Pages/FundsCenter/AllFunds/FundsFilters/FundsSearch';
import BaseFilter, { Filter } from 'components/Functional/Filters/BaseFilter';
import useFilters from 'hooks/useFilters';

type Props = {
  filters: Filter[];
  showDatePicker?: boolean;
  allowSearchByISIN?: boolean;
  className?: string;
  cookieName?: string;
  label?: string;
};

const FundsFiltersSection = ({
  filters,
  showDatePicker = true,
  className = '',
  cookieName = 'fundsSearchHistory',
  label = null,
  allowSearchByISIN = true,
}: Props) => {
  const {
    formattedFilters,
    fetchFacets,
    onOptionSelect,
    appliedOptions,
    allOptions,
    onClearFilterSelection,
    onResetUnAppliedOptions,
    isFetching,
    selectedOptions,
    onFilterApply,
    unApplyOptions,
  } = useFilters({ needFacets: true, filters });
  const labelContent =
    label ?? 'ISIN code searches should use a 12 digital-alpha numeric format e.g US0032616098';
  return (
    <div
      className={classNames(
        'funds-filter px-2 py-5 px-md-5 background-digital-light-grey',
        className
      )}
    >
      <FundsSearch
        allowSearchByISIN={allowSearchByISIN}
        label={labelContent}
        cookieNameProp={cookieName}
      />
      <BaseFilter
        className="mt-4 mt-lg-5"
        filters={formattedFilters}
        isFetching={isFetching}
        showDatePicker={showDatePicker}
        filterApply={onFilterApply}
        unApplyOptions={unApplyOptions}
        needAggregateCount={fetchFacets}
        onOptionSelect={onOptionSelect}
        appliedOptions={appliedOptions}
        allOptions={allOptions}
        onClearFilterSelection={onClearFilterSelection}
        onResetUnAppliedOptions={onResetUnAppliedOptions}
        selectedOptions={selectedOptions}
      />
    </div>
  );
};

export default FundsFiltersSection;
